import script from "./bread_crumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./bread_crumbs.vue?vue&type=script&setup=true&lang=js"

import "./bread_crumbs.vue?vue&type=style&index=0&id=ed8683de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed8683de"]])

export default __exports__